import React,{useState,useEffect} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import PacmanLoader from "react-spinners/PacmanLoader";
import {useNavigate} from "react-router-dom";

const styleTittle = {

    fontSize: 20,

    color: "#4a54f1",

    textAlign: "center",

    paddingBottom: "60px",
}

const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const TambahBarang = () => {
const [jenisKategori, setjenisKategori] = useState("");
const [loading, setLoading] = useState(false);
const navigate = useNavigate();



useEffect(() => {

},[]);


const saveKategori = async (e) =>{
    e.preventDefault();
    setLoading(true)
    let formData = new FormData();
        formData.append('jenisKategori',jenisKategori);
    try {
        await axios.post(`${process.env.REACT_APP_MASTER_URL}/tambahkategori`,formData,{
            headers:{ 
                'Content-Type':'multipart/form-data'
            }
        });
        toast.info("Kategori Berhasil Ditambahkan");
        navigate("/kategori")
    } catch (error) {
        setLoading(false)
        console.log("error: ",error);
    }
        
}

  return (
    <section className="hero has-background-grey-light is-fullheight is-fullwidth">
        {loading ?
            <div style={stylespinner}>
                <PacmanLoader
                    color={'#301E67'}
                    loading={loading}
                    size={30}
                    textAlign='centered'
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                </div> 
        :
        <div className="section is-fullheight" style={{backgroundColor: '#1b48f1', filterImage:'blur(50px)'}} >
        <div className='field' ></div>
        <div className="container ">
            <div className="column is-6 is-offset-3">
            <div className="box" >
                    <img src={`${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`}  alt="Not Found" width={300} height={300}></img>
                    <label className='label' style={styleTittle}><center>Form Tambah Kategori</center></label>
                <form onSubmit={saveKategori}>
                    <div className='field'>
                        <label className='label'>jenis Kategori</label>
                        <div class='control' has-icons-left has-icons-right>
                            <input required type='text' className="input" value={jenisKategori} onChange={(e)=> setjenisKategori(e.target.value)} placeholder='Nama Barang'></input>                    </div>
                    </div>       
                    <div className='field mt-5'>
                        <button type='submit' className='button is-link'>Save</button>
                        <button type="button" onClick={() => navigate(-1)} className='button is-primary ml-5'>Back</button>
                    </div>
                </form>
            </div>
        </div>
        </div>
        </div>
        }
    </section>
  )
}

export default TambahBarang